import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SocialBar from '../../components/SocialBar/SocialBar';
import './References.css';

function References() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('Hepsi');
  const [hoverPhone, setHoverPhone] = useState(false); // Telefon hover durumu

  const API_URL = 'https://erya-backend.onrender.com/api/projects';

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error(`Projeler alınamadı: ${response.status} ${response.statusText}`);

        const data = await response.json();
        setProjects(Array.isArray(data) ? data : data.projects || []);
      } catch (err) {
        console.error('Projeler yüklenirken hata oluştu:', err);
        setError(err.message || 'Projeler yüklenirken bilinmeyen bir hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [API_URL]);

  const categories = ['Hepsi', 'Yurt İçi', 'Yurt Dışı'];

  const filteredProjects =
    selectedCategory === 'Hepsi'
      ? projects
      : projects.filter(project => project.category === selectedCategory);

  if (loading) return <p className="loading-message">Projeler yükleniyor...</p>;
  if (error) return <p className="error-message">Hata: {error}</p>;

  return (
    <div className="references-page">
      {/* SocialBar */}
      <SocialBar hoverPhone={hoverPhone} />

      {/* Sayfa başlığı */}
      <h1 className="references-title">Referanslarımız</h1>

      {/* Kategori butonları */}
      <div className="category-buttons">
        {categories.map(category => (
          <button
            key={category}
            className={`category-button ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Projeler tablosu */}
      <div className="references-table-wrapper">
        {filteredProjects.length === 0 ? (
          <p className="no-projects-message">Bu kategoriye ait proje bulunamadı.</p>
        ) : (
          <table className="references-table">
            <thead>
              <tr>
                <th>Proje Adı</th>
                <th>Kullanım</th>
                <th>Proje Konumu</th>
                <th>Tamamlanma Tarihi</th>
                <th>Yapılan Alan</th>
              </tr>
            </thead>
           <tbody>
  {filteredProjects.map(project => (
    <tr key={project._id}>
      <td>{project.title}</td>
      <td>
        {Array.isArray(project.usage)
          ? project.usage.join(' - ')
          : project.usage}
      </td>
      <td>{project.location}</td>
      <td>{project.completionStatus === 'Tamamlandı' ? project.completionDate : '-'}</td>
      <td>{project.area || '-'}</td>
    </tr>
  ))}
</tbody>

          </table>
        )}
      </div>

      {/* Contact link */}
      <p
        className="contact-link-text"
        style={{ cursor: 'pointer', marginTop: '20px', fontWeight: 'bold', textAlign: 'center' }}
        onClick={() => navigate('/contact')}
        onMouseEnter={() => setHoverPhone(true)}
        onMouseLeave={() => setHoverPhone(false)}
      >
        Referanslarımızın Detayları İçin Bize Ulaşabilirsiniz
      </p>
    </div>
  );
}

export default References;
